import { aggregateCustomInputs } from "#modules/quoteRequestLines/domain/aggregateCustomInputs";
import { Group } from "#shared/view/components/Group";

import { CustomInputsDto } from "../useCustomInputs";
import { CustomInputRow } from "./CustomInputRow";

type Props = {
  customInputs: CustomInputsDto;
  quoteRequestLineId: string | undefined;
  isPredicting: boolean;
};

export const CustomInputsList = ({ customInputs, quoteRequestLineId, isPredicting }: Props) => {
  const aggregatedCustomInputs = aggregateCustomInputs(customInputs);

  return (
    <Group gap="sm">
      {aggregatedCustomInputs
        .sort((a, b) => a.index - b.index)
        .map((customInput) => (
          <CustomInputRow
            key={customInput.key}
            customInput={customInput}
            quoteRequestLineId={quoteRequestLineId}
            isPredicting={isPredicting}
          />
        ))}
    </Group>
  );
};
